import { useState, useEffect } from 'react';
interface useWindowWidth {
  windowWidth: number;
}

export default function useWindowWidth(): useWindowWidth {
  const [windowWidth, setWW] = useState(0);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWW(window.innerWidth);
      window.addEventListener('resize', () => setWW(window.innerWidth));
      return () => window.removeEventListener('resize', () => setWW(window.innerWidth));
    }
  }, []);

  return {
    windowWidth,
  };
}
